<template>
  <v-container>
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout class="back pb-3 pt-3">
      <v-btn icon small @click="goBack()">
        <v-icon class="text--darken-1">arrow_back</v-icon>
      </v-btn>
      <v-layout align-center justify-center>
        <span class="font-weight-medium title">Abastecimento</span>
      </v-layout>
    </v-layout>

    <v-divider class="my-2"></v-divider>
    <v-layout text-center column pt-2 mb-15>
      <span class="subheading font-weight-medium pt-5 pb-5">
        Para reabastecer, utilize o cartão combustível localizado no porta-luvas
        do veículo.
      </span>
      <v-layout row class="mx-4 mt-3">
        <v-flex xs6>
          <v-layout fill-height column text-left align-start justify-center>
            <span class="subheading font-weight-medium">Senha/Matrícula:</span>
            <span
              class="blue--text text--darken-1 display-1 font-weight-medium"
              >{{ vehicleRequest.vehicle.card_password }}</span
            >

            <span class="subheading font-weight-medium pt-2">Combustível:</span>
            <span class="blue--text text--darken-1 display-1 font-weight-medium"
              >ÁLCOOL</span
            >
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout fill-height column align-end justify-center>
            <v-img
              :src="require(`@/assets/maquina-de-cartao.png`)"
              style="width: 75%"
            ></v-img>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-flex class="text-center agreed-stations pt-6" align-end justify-center>
        <v-btn
          large
          text
          class="agreed-posts"
          style="width: 96%"
          href="https://maps.goodcard.com.br/ondecomprar/index.php?portal=ticketlog"
        >
          <span><strong>VER POSTOS CONVENIADOS</strong></span>
        </v-btn>
        <v-btn
          large
          text
          class="agreed-posts"
          style="width: 96%"
          @click="showRefuelDialog = true"
        >
          <span><strong>Anexar comprovante</strong></span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showRefuelDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Comprovante de abastecimento</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <label>Valor abastecido:</label>
              <money
                v-model="vlrNota"
                v-bind="money"
                class="form-control"
              ></money>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="identifyAndroid()">
              <v-btn
                large
                text
                class="agreed-posts"
                style="width: 96%"
                @click="capture()"
              >
                <span><strong>Anexar comprovante</strong></span>
                <label class="selectImgIcon">
                  <v-icon size="60" color="success" v-if="selectedImg"
                    >done_outline</v-icon
                  >
                </label>
              </v-btn>
            </v-col>
            <v-col v-else>
              <label for="selectFile" class="selectImgIcon">
                <v-icon>mdi-file-document-multiple-outline</v-icon>
                <span class="font-weight-bold">Anexar comprovante</span>
                <v-icon size="60" color="success" v-if="selectedImg"
                  >done_outline</v-icon
                >
              </label>
              <input
                capture="environment"
                id="selectFile"
                type="file"
                style="display: none"
                accept="image/*"
                @change="onFileSelected"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showRefuelDialog = false">
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="enviarComprovante()"
            :disabled="!selectedImg"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FinishRefuel
      :show="showFinishRefuel"
      :coupon="coupon"
      @copyCoupon="copyCouponAlert()"
      @entendi="
        $router.push({
          name: 'driver-vehicle-request-dashboard',
        })
      "
    ></FinishRefuel>
  </v-container>
</template>

<script>
function cFile2Blob(cfile, cb) {
  let fr = new FileReader();
  fr.onloadend = (ev) => {
    let b = new Blob([ev.target.result], { type: 'image/jpeg' });
    b.name = cfile.name;
    cb(b);
  };
  fr.readAsArrayBuffer(cfile);
}
import HistoricoAbastecimentoController from './../../controllers/HistoricoAbastecimentoController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import FinishRefuel from './FinishRefuel';
export default {
  components: {
    FinishRefuel,
  },
  data() {
    return {
      coupon: {},
      showFinishRefuel: false,
      vehicleRequestId: this.$route.params.vehicleRequestId,
      historicoAbastecimentoController: new HistoricoAbastecimentoController(
        this.$resource
      ),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      comprovanteImage: '',
      data: new FormData(),
      showRefuelDialog: false,
      vehicleRequest: {},
      vlrNota: '',
      cardPassword: '',
      money: {
        prefix: 'R$ ',
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
      },
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      selectedImg: false,
    };
  },
  async created() {
    this.vehicleRequestController.getById(this.vehicleRequestId).then((res) => {
      this.vehicleRequest = res;
    });
  },
  methods: {
    copyCouponAlert() {
      this.alert('Cupom copiado com sucesso!', 'success');
    },
    alert(text, color) {
      console.log(text, color);
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    enviarComprovante() {
      this.data.delete('form');
      this.data.append(
        'form',
        JSON.stringify({
          vlrNota: this.vlrNota.toFixed(2).replace('.', ''),
          vehicleRequestId: this.vehicleRequestId,
        })
      );
      this.historicoAbastecimentoController
        .refuel(this.data)
        .then((res) => {
          this.alert(res.message, 'success');
          this.showRefuelDialog = false;
          this.coupon = res.coupon;
          this.showFinishRefuel = true;
        })
        .catch((error) => {
          this.alert(error.body.message, 'error');
        });
    },
    goBack() {
      this.$router.push({ name: 'driver-vehicle-request-dashboard' });
    },
    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) {
        return true;
      } else {
        return false;
      }
    },
    async onFileSelected(e) {
      this.data = new FormData();
      let image = e.target.files[0];
      // compactação inicio
      const width = 100;
      const fileName = e.target.files[0].name;
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        try {
          const elem = document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height tem as dimensões originais
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              image = file;
            },
            'image/jpeg',
            1
          );
          this.selectedImg = true;
          this.data.append('cnhImage', image);
        } catch (error) {
          console.log(error);
        }
      };
    },
    capture() {
      navigator.camera.getPicture(this.onSuccess.bind(this), () => {}, {
        quality: 50,
        destinationType: Camera.DestinationType.FILE_URI,
      });
    },
    onSuccess(imageURI) {
      this.comprovanteImage = imageURI;
      this.selectedImg = true;
      this.uploadAndroid();
    },
    async uploadAndroid() {
      this.data = new FormData();
      return new Promise(
        (resolve, reject) => {
          window.resolveLocalFileSystemURL(
            this.comprovanteImage,
            (fileEntry) => {
              fileEntry.file((cfile) => {
                cFile2Blob(cfile, (blob) => {
                  this.data.append('cnhImage', blob);
                  resolve();
                });
              });
            }
          );
        },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 10px;
}
.selectImgIcon {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 70%;
  margin-top: -40px;
}
</style>
